import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { URL } from '../../../constant';
import { Login } from './';
import { Join, Success } from './join';
import { Policy, Terms, Marketing, Privacy } from '../MathPid/policy';

const {
  LOGIN, POLICY, JOIN,
  // ID_INQUIRY, PW_INQUIRY, MY_PAGE
} = URL.ACCOUNT;

function AccountMathPid() {
  return (
    <Switch>
      <Route path={LOGIN} component={Login} />
      <Route path={JOIN.I} component={Join} exact/>
      <Route path={JOIN.SUCCESS} component={Success} exact/>
      <Route path={POLICY.I} component={Policy} exact/>
      <Route path={POLICY.TERMS} component={Terms} exact/>
      <Route path={POLICY.MARKETING} component={Marketing} exact/>
      <Route path={POLICY.PRIVACY} component={Privacy} exact/>
    </Switch>
  );
}

export default AccountMathPid;